export function SET_RETURN_ORDER_INFO(state, detail) {
  state.detail = Object.assign({}, state.detail, detail)
}

export function SET_RETURN_REASONS_INFO(state, reasons) {
  state.reasons = reasons
}
